<div class="p-4">
    
  <i class="material-icons float-end" [mat-dialog-close]="">close</i>
    <h3>{{data.title}}</h3>
    <p>{{data.text}}</p>
    <button class="primary" [mat-dialog-close]="" *ngIf="data.button != null">{{data.buttonText}}</button>
</div>